import React, { useState } from "react";
import emailicon from "../../images/emailchecker.png";
import { Link } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { RESEND_EMAIL } from "../../mutation/ResendEmail";
import FullWidthLayout from "../Common/FullwidthLayout";

const SignupVerify = () => {
  const [resendEmailError, setResendEmailError] = useState("");

  const emailIDVal = localStorage.getItem("resend_signup_email")
    ? localStorage.getItem("resend_signup_email")
    : "abc@abc.com";

  const clickHandler = () => {
    ResendEmailVerify({
      variables: {
        email: emailIDVal,
      },
    }).catch((e) => {
      const errors = e.graphQLErrors;
      if (errors[0] && errors[0].message) {
        setResendEmailError(errors[0].message);
      }
    });
  };

  const [ResendEmailVerify] = useMutation(RESEND_EMAIL);

  return (
    <FullWidthLayout>
      <div className="login-cover signupverify">
        <div className="login-box">
          <div className="email-verify">
            <div className="icon">
              <img src={emailicon} alt="icon" />
            </div>
          </div>
          <h2>Check your email</h2>
          <div className="signup-verify-content">
            <p>
              We have sent a mail with verification link.Please check your
              email. Tap the link to verify your account and to get started!
            </p>
          </div>
          <div className="email-verify-button">
            <Link to="#" onClick={clickHandler} className="resend-email-btn">
              Resend email
            </Link>
            <Link to="/login" className="signin-btn">
              Sign in
            </Link>
          </div>
          <div
            className="error-message"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          >
            {resendEmailError}
          </div>
        </div>
      </div>
    </FullWidthLayout>
  );
};

export default SignupVerify;
